import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performGetRequestWithRetry } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { AtlassianAccount } from '../common/types.tsx';
import { GET_ME_URL } from './constants.tsx';

export const getAtlassianAccountWithRethrow = async ({
	source,
}: { source?: string } = {}): Promise<AtlassianAccount | null> => {
	try {
		const response = await performGetRequestWithRetry(GET_ME_URL);

		if (!response || typeof response !== 'object') {
			return null;
		}

		return {
			extendedProfile: {
				jobTitle: response.extended_profile?.job_title,
				teamType: response.extended_profile?.team_type,
			},
			email: response.email,
			accountId: response.account_id,
		};
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'getAtlassianAccountWithRethrow',
				packageName: 'jiraAtlassianAccount',
				teamName: 'jlove-makkuro',
			},
			attributes: {
				source,
			},
			error,
		});
		throw error;
	}
};
